import { jsx } from 'react/jsx-runtime';
import { useRef, useEffect } from 'react';
import { INPUT_KEY_BACKSPACE } from '../constants/input/index.js';
import { I as Input } from './component-DchS1oBD.js';
import { s as styleInject } from './style-inject.es-tgCJW-Cu.js';

var css_248z = ".SGCM_UIKIT_REACT_OtpInput_containerRoot_15wyl_1 {\n  display: flex;\n  justify-content: space-between;\n  column-gap: 30px;\n}\n\n.SGCM_UIKIT_REACT_OtpInput_inputOptDigit_15wyl_7 {\n  width: 36px;\n  padding: 11px 0;\n  text-align: center;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGFBQWE7RUFDYiw4QkFBOEI7RUFDOUIsZ0JBQWdCO0FBQ2xCOztBQUVBO0VBQ0UsV0FBVztFQUNYLGVBQWU7RUFDZixrQkFBa0I7QUFDcEIiLCJmaWxlIjoic3R5bGVzLm1vZHVsZS5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmNvbnRhaW5lclJvb3Qge1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gIGNvbHVtbi1nYXA6IDMwcHg7XG59XG5cbi5pbnB1dE9wdERpZ2l0IHtcbiAgd2lkdGg6IDM2cHg7XG4gIHBhZGRpbmc6IDExcHggMDtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xufSJdfQ== */";
var styles = {"containerRoot":"SGCM_UIKIT_REACT_OtpInput_containerRoot_15wyl_1","inputOptDigit":"SGCM_UIKIT_REACT_OtpInput_inputOptDigit_15wyl_7"};
styleInject(css_248z);

const isOtpDigit = (value) => (typeof value === 'number'
    && Number.isInteger(value)
    && value >= 0
    && value <= 9);
const isOtpCode = (value) => (Array.isArray(value)
    && value.length === 4
    && value.every(isOtpDigit));
const isPartialOtpCode = (value) => (Array.isArray(value)
    && value.length === 4
    && value.every(item => isOtpDigit(item) || item === undefined));
const convertToOtpCode = (value) => {
    if (value.length !== 4) {
        return null;
    }
    const digitList = value.split('').map(char => +char);
    return isOtpCode(digitList) ? digitList : null;
};
const convertToOtpDigit = (char) => {
    if (char === '') {
        return undefined;
    }
    const optDigit = +char;
    return isOtpDigit(optDigit) ? optDigit : null;
};

const OtpInput = ({ autoFocusFirstInput, disabled, isInvalid, value, onChange, }) => {
    const otpDigitInputElList = useRef([
        undefined,
        undefined,
        undefined,
        undefined,
    ]);
    const optInputList = value.map((otpDigit, index) => ({
        key: `otp-code-${index}`,
        digit: otpDigit,
        index,
    }));
    const onOtpDigitChange = (index, newValue) => {
        const newDigit = convertToOtpDigit(newValue);
        if (newDigit === null) {
            return;
        }
        const newDigitCode = [...value];
        newDigitCode[index] = newDigit;
        onChange?.(newDigitCode);
    };
    const onOtpDigitListChange = ({ list, onSuccess, }) => {
        const newDigitCode = [...value];
        let hasChange = false;
        for (const [changeIndex, newValue] of list) {
            const newDigit = convertToOtpDigit(newValue);
            if (newDigit === null) {
                return;
            }
            newDigitCode[changeIndex] = newDigit;
            if (!hasChange) {
                hasChange = true;
            }
        }
        if (!hasChange) {
            return;
        }
        onChange?.(newDigitCode);
        onSuccess?.();
    };
    const onPasteOtpCode = (newDigitCode) => {
        if (!newDigitCode) {
            return;
        }
        onChange?.(newDigitCode);
    };
    useEffect(() => {
        if (!autoFocusFirstInput) {
            return;
        }
        otpDigitInputElList.current[0]?.click();
        otpDigitInputElList.current[0]?.focus();
    }, [autoFocusFirstInput]);
    return (jsx("div", { className: styles.containerRoot, children: optInputList.map(({ key, digit = '', index, }) => (jsx(Input, { ref: (el) => {
                otpDigitInputElList.current[index] = el ?? undefined;
            }, className: styles.inputOptDigit, disabled: disabled, inputMode: "numeric", isInvalid: isInvalid, type: "text", value: digit, onChange: (event) => {
                const newValue = event.target.value;
                const { length: newValueLength } = newValue;
                if (newValueLength === optInputList.length) {
                    const newDigitCode = convertToOtpCode(newValue);
                    onPasteOtpCode(newDigitCode);
                }
                if (newValueLength === 2) {
                    if (index > 2) {
                        return;
                    }
                    const nextIndex = index + 1;
                    onOtpDigitListChange({
                        list: [
                            [index, newValue[0]],
                            [nextIndex, newValue[1]],
                        ],
                        onSuccess: () => {
                            otpDigitInputElList.current[nextIndex]?.focus();
                        },
                    });
                    return;
                }
                if (newValueLength < 2) {
                    onOtpDigitChange(index, newValue);
                    if (newValue === '') {
                        return;
                    }
                    otpDigitInputElList.current[index + 1]?.focus();
                }
            }, onKeyDown: ({ key: inputKey, currentTarget: { value: newValue, }, }) => {
                if (inputKey !== INPUT_KEY_BACKSPACE
                    || newValue !== ''
                    || index < 1) {
                    return;
                }
                const previousIndex = index - 1;
                onOtpDigitChange(previousIndex, '');
                otpDigitInputElList.current[previousIndex]?.focus();
            }, onPaste: (event) => {
                event.preventDefault();
                const newDigitCode = convertToOtpCode(event.clipboardData.getData('text'));
                onPasteOtpCode(newDigitCode);
            } }, key))) }));
};

export { OtpInput as O, convertToOtpDigit as a, isOtpDigit as b, convertToOtpCode as c, isPartialOtpCode as d, isOtpCode as i };
//# sourceMappingURL=component-B90vhDvV.js.map
